import styled from '@emotion/styled'
import { InputLabel, ListSubheader, MenuItem, Select, TextField } from '@mui/material'
import theme from 'theme'

export const StyledInputLabel = styled(InputLabel)`
  color: ${theme.colors.devicesSecondaryText};
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  &.Mui-focused {
    color: ${theme.colors.dropdownLabel};
    background-color: ${theme.colors.labelCardBg};
  }

  /* Reset to original position when not focused and not filled */
  &:not(.Mui-focused):not(.MuiFormLabel-filled) {
    transform: translate(${theme.spacing.xMd}px, ${theme.spacing.small}px) scale(1);
  }

  &[data-shrink='true'] {
    color: ${theme.colors.dropdownLabel};
    background-color: ${theme.colors.labelCardBg};
  }
`

export const StyledSelect = styled(Select)`
  color: ${theme.colors.devicesSecondaryText};
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: ${theme.attributes.borderRadius.tertiary};

  &.Mui-focused fieldset {
    border: 1px solid ${theme.colors.cta} !important;
    border-radius: ${theme.attributes.borderRadius.tertiary};
  }

  & fieldset {
    border: none;
  }

  & svg {
    color: ${theme.colors.devicesSecondaryText} !important;
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`

export const StyledListSubheader = styled(ListSubheader)`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: ${theme.spacing.xSmall}px ${theme.spacing.xSmall}px 0 ${theme.spacing.xSmall}px;
  background-color: ${theme.colors.menuBg};
`

export const StyledTextField = styled(TextField)`
  background-color: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.mediumSmall};

  input,
  svg {
    color: ${theme.colors.devicesSecondaryText};
  }

  fieldset {
    border: none;
  }

  /* White on the white menu reads as no field at all; match the filled search in the CPI dropdown. */
  html[data-theme='light'] & {
    background-color: ${theme.colors.cardFillTertiary};
  }
`

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.sm}px ${theme.spacing.small}px;
  cursor: pointer;

  &:hover,
  &.Mui-selected:hover,
  &.hovered {
    background-color: ${theme.colors.surfaceContainerBackground};

    .MuiFormControlLabel-label,
    svg {
      color: ${theme.colors.cta};
    }
  }

  &.Mui-selected {
    background-color: ${theme.colors.surfaceContainerBackground};
  }

  html[data-theme='light'] & {
    &:hover,
    &.Mui-selected:hover,
    &.hovered,
    &.Mui-selected {
      background-color: ${theme.colors.menuItemHover};
    }
  }

  &.not-found {
    pointer-events: none;
  }

  & svg {
    font-size: ${theme.iconSize.small}px;
  }

  & .MuiFormControlLabel-label {
    font-size: ${theme.typography.fontSize.large};
  }
`
